<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemPost.query.postCode')">
                <a-input v-model="queryParam.postCode" :placeholder="$t('views.systemPost.query.postCodePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemPost.query.postName')">
                <a-input v-model="queryParam.postName" :placeholder="$t('views.systemPost.query.postNamePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemPost.query.status')">
                <a-select :placeholder="$t('views.systemPost.query.statusPlaceholder')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in localizedStatusOptions" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.systemPost.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.systemPost.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:post:add']">
          <a-icon type="plus" />{{ $t('views.systemPost.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['system:post:edit']">
          <a-icon type="edit" />{{ $t('views.systemPost.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:post:remove']">
          <a-icon type="delete" />{{ $t('views.systemPost.btn.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="displayColumns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered">
        <a-switch slot="status" slot-scope="text, record" @change="changeStatus($event,record)" :checked="record.status === 1 " />
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:post:edit']">
            <a-icon type="edit" />{{ $t('views.systemPost.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['system:post:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['system:post:remove']">
            <a-icon type="delete" />{{ $t('views.systemPost.btn.delete') }}
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="showPaginationTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { pagePost, delPost, updatePost } from '@/api/system/post'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Post',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined
      },
      columns: [
        {
          title: '',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'postCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'postName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'postSort',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    localizedStatusOptions () {
      return this.localizeDictOptions(this.dict.type['sys_enable_disable'], 'views.systemPost.dict.status')
    },
    displayColumns () {
      const titleKeyByDataIndex = {
        id: 'views.systemPost.column.id',
        postCode: 'views.systemPost.column.postCode',
        postName: 'views.systemPost.column.postName',
        postSort: 'views.systemPost.column.postSort',
        status: 'views.systemPost.column.status',
        createTime: 'views.systemPost.column.createTime',
        operation: 'views.systemPost.column.operation'
      }
      return this.columns.map(col => {
        const key = titleKeyByDataIndex[col.dataIndex]
        return {
          ...col,
          title: key ? this.$t(key) : col.title
        }
      })
    }
  },
  methods: {
    localizeDictOptions (options, keyPrefix) {
      return (options || []).map(item => {
        const i18nKey = `${keyPrefix}.${item.value}`
        return {
          ...item,
          label: this.$te(i18nKey) ? this.$t(i18nKey) : item.label
        }
      })
    },
    showPaginationTotal (total) {
      return this.$t('views.systemPost.pagination.total', { total })
    },
    changeStatus (e, record) {
      const oldStatus = record.status
      const newOldRecord = JSON.parse(JSON.stringify(record))
      newOldRecord.status = e ? 1 : 0
      const status = e ? 1 : 0
      const action = oldStatus === 0
        ? this.$t('views.systemPost.status.enable')
        : this.$t('views.systemPost.status.disable')
      updatePost(newOldRecord).then((res) => {
        if (res.success) {
          record.status = status
          this.$message.success(this.$t('views.systemPost.msg.statusSuccess', { action }), 3)
        } else {
          record.status = oldStatus
          this.$message.error(this.$t('views.systemPost.msg.statusFail', { action, message: res.message }), 3)
        }
      }).catch(() => {
        this.$message.error(this.$t('views.systemPost.msg.statusException', { action }), 3)
      })
    },
    getList () {
      this.loading = true
      pagePost(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete (row) {
      const that = this
      const postIds = row.id || this.ids
      this.$confirm({
        title: this.$t('views.systemPost.confirm.deleteTitle'),
        content: this.$t('views.systemPost.confirm.deleteContent', { ids: postIds }),
        onOk () {
          return delPost(postIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('views.systemPost.msg.deleteSuccess'), 3)
            })
        },
        onCancel () {}
      })
    },
    handleExport () {
      const that = this
      this.$confirm({
        title: this.$t('views.systemPost.confirm.exportTitle'),
        content: this.$t('views.systemPost.confirm.exportContent'),
        onOk () {
          that.download('system/post/export', {
            ...that.queryParam
          }, `post_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
